import type { DeliveryInfo } from '../../domain/models/DeliveryInfo';
import type { PdpDeliveryResponseDTO } from '../dto/pdpDelivery.dto';

export function deliveryDtoToDeliveryInfo(dto: PdpDeliveryResponseDTO): DeliveryInfo {
  return {
    edd: dto.edd ?? null,
    eddFullDate: dto.eddFullDate ?? null,
    defaultDeliveryDate: dto.defaultDeliveryDate ?? '',
    warehouseDeliveryDate: dto.warehouseDeliveryDate ?? '',
    pincode: dto.pincode ?? '',
    cityName: dto.cityName ?? null,
    nddPincode: dto.nddPincode ?? null,
    showAvailableTomorrow: dto.showAvailableTomorrow ?? false,
    designEddDetails: dto.designEddDetails ?? null,
  };
}
